import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=3c0167f2&scoped=true"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
import style0 from "./Link.vue?vue&type=style&index=0&id=3c0167f2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0167f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0167f2')) {
      api.createRecord('3c0167f2', component.options)
    } else {
      api.reload('3c0167f2', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=3c0167f2&scoped=true", function () {
      api.rerender('3c0167f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Link.vue"
export default component.exports